import { usePlatformUpdate } from '@reapitform/hooks'

export const useDefaultsLinkDelete = (id: string) => {
  const path: string = `/api/Organization/DefaultLink/${id}`

  const [deleteLink, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<undefined, any>({
    path: path,
    method: 'DELETE',
    headers: {},
    errorMessage: 'Failed to delete the Link',
    successMessage: 'Link successfully deleted',
  })

  return { deleteLink, returnData, isLoading, isSuccess, isError }
}
